import Table from "react-bootstrap/Table";
import React, { Fragment } from "react";
import { UserLink } from "../util/Links";
import { ShiftTableTitle } from "./ShiftTableTitle";

const ShiftAssociatedBookingElement = ({ shift }) => {
  if (shift === null || shift === undefined) return;

  if (shift?.user?.id === null || shift?.user?.id === undefined) return;

  return (
    <Fragment>
      <ShiftTableTitle title={"Associated Booking"} />
      <Table striped hover responsive>
        <tbody>
          <tr>
            <td>Status</td>
            <td className={"font-weight-bold"}>{shift?.status}</td>
          </tr>
          <tr>
            <td>Nurse</td>
            <td className={"font-weight-bold"}>{UserLink(shift?.user)}</td>
          </tr>
          <tr>
            <td>ApprovedBy</td>
            <td className={"font-weight-bold"}>
              {UserLink(shift?.approvedBy)}
            </td>
          </tr>
          <tr>
            <td>Email</td>
            <td className={"font-weight-bold"}>{shift?.user?.email}</td>
          </tr>
          <tr>
            <td>Telephone</td>
            <td className={"font-weight-bold"}>{shift?.user?.telephone}</td>
          </tr>
        </tbody>
      </Table>
    </Fragment>
  );
};

export default ShiftAssociatedBookingElement;
